import { Layout } from "./layout";
import { Subject } from "rxjs";

export abstract class ILayoutsRepository {
  layoutUpdated: Subject<Layout>;
  layoutCreated: Subject<Layout>;
  abstract getLayouts(
    nameFilter?: string,
    layoutId?: string,
  ): Promise<Layout[]>;
  abstract createOrUpdate(layout: Layout): Promise<void>;
  abstract delete(layoutId: string): Promise<void>;
}
